import { sendRequest } from "../../hooks/requests/useRequest";

export async function getAllAgreement() {
    const requestOptions = {
        method: 'GET'
    };

    const response = await sendRequest(requestOptions, `Agreement/List`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            msg: response?.data?.msg
        };
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}

export async function deleteAgreement({
    agreementId
}) {

    const requestOptions = {
        method: 'DELETE',
    };

    const response = await sendRequest(
        requestOptions, `Agreement/${agreementId}`
    );

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response.data
        }
    else
        return {
            code: response.code,
            data: response.data
        }
}


export async function saveStatusAgreement(
    id_agreement,
    status,
) {

    const body = {
        "id_agreement": id_agreement,
        "status": status,
    };


    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, `Agreement/UpdateStatus`
    );

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response.data
        }
    else
        return {
            code: response.code,
            data: response.data
        }
}


export async function getViewHistorical(id_agreement) {
    let requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Company/ViewHistoricalAgreement/${id_agreement}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}
